import styled, { css } from 'styled-components';
import { SimpleArrow } from '../icons/SimpleArrow';

const transparent20 = 'rgba(0, 0, 0, 0.23)';

export const ArrowIcon = styled(SimpleArrow)`
  height: 12px;
  padding-right: 0.5rem;
  transition: transform 0.2s;
`;

export const PlaceholderBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 50%;
  bottom: 0;
  left: 0;
  z-index: -1;
`;

export const Placeholder = styled.span<{
  $atTop?: boolean;
  disabled?: boolean;
}>`
  position: absolute;
  color: ${({ theme }) => theme.colors.textGrey};
  font-size: ${({ $atTop }) => ($atTop ? '12px' : '13px')};
  transform: ${({ $atTop }) =>
    $atTop ? 'translateY(-13px)' : 'translateY(12px)'};
  padding: 0 8px;
  left: 0.5rem;
  transition: transform 0.1s, font-size 0.1s;

  & > ${PlaceholderBackground} {
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.lightestGray : theme.colors.white};
  }
`;

export const InputWrapper = styled.label<{ $active: boolean }>`
  height: 45.5px;
  display: flex;
  border-style: solid;
  border-width: 1px;
  border-radius: 1px;
  border-color: ${({ $active, theme }) =>
    $active ? theme.colors.lightBlue : theme.colors.lightGrey};
  transition: border-color 0.1s;
  box-sizing: border-box;
  line-height: 1.1875em;
  padding: 1px;
  position: relative;

  &:hover {
    border-color: ${({ $active, theme }) =>
      $active ? theme.colors.lightBlue : theme.colors.textGrey};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.lightBlue};
  }

  &:focus-within ${ArrowIcon} {
    transform: ${({ $active }) => ($active ? 'scaleY(-1)' : null)};
  }

  &:focus-within ${Placeholder} {
    font-size: 12px;
    transform: translateY(-13px);
  }
`;

export const InputField = styled.input<{
  disabled?: boolean;
  readOnly?: boolean;
}>`
  padding: 3px 15px;
  font-size: 14px;
  width: 100%;
  color: ${({ theme }) => theme.colors.darkBlue};
  transition: color 0.1s;
  text-overflow: ellipsis;

  box-sizing: content-box;
  background-color: transparent;
  outline: 0;
  border: 0;
  cursor: ${({ disabled, readOnly }) => {
    if (!disabled) return readOnly ? 'pointer' : 'text';
    return 'default';
  }};

  &:hover {
    color: ${({ theme }) => theme.colors.darkBlue};
  }
`;

export const Container = styled.div<{ disabled?: boolean; $hasError: boolean }>`
  position: relative;

  & > ${InputWrapper} {
    border-color: ${({ disabled }) => (disabled ? transparent20 : null)};
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.lightestGray : undefined};
  }

  ${({ theme, $hasError }) =>
    $hasError &&
    css`
      & ${InputWrapper} {
        border-color: ${theme.colors.red};
      }
    `}
`;

export const Prefix = styled.div``;
export const Postfix = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
`;
